import React from 'react';
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from './components/ui/sonner';
import { useSmoothScroll } from './hooks/useSmoothScroll';

import Navigation from './components/Navigation';
import Footer from './components/Footer';
import WhatsAppButton from './components/WhatsAppButton';
import CookieConsent from './components/CookieConsent';
import ScrollToTop from './components/ScrollToTop';

import Home from './pages/Home';
import TimeCritical from './pages/TimeCritical';
import AirFreight from './pages/AirFreight';
import RoadFreight from './pages/RoadFreight';
import SeaFreight from './pages/SeaFreight';
import OnboardCourier from './pages/OnboardCourier';
import AircraftCharter from './pages/AircraftCharter';
import DangerousGoods from './pages/DangerousGoods';
import Customs from './pages/Customs';
import About from './pages/About';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import Insights from './pages/Insights';
import ArticleDetail from './pages/ArticleDetail';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import NotFound from './pages/NotFound';
import { PrivacyPolicy, CookiePolicy, Terms } from './pages/Legal';

function AppContent() {
  useSmoothScroll();
  const location = useLocation();
  const isAdmin = location.pathname.startsWith('/admin');

  return (
    <div className="app-container">
      <ScrollToTop />
      {!isAdmin && <Navigation />}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/time-critical" element={<TimeCritical />} />
        <Route path="/air-freight" element={<AirFreight />} />
        <Route path="/road-freight" element={<RoadFreight />} />
        <Route path="/sea-freight" element={<SeaFreight />} />
        <Route path="/onboard-courier" element={<OnboardCourier />} />
        <Route path="/aircraft-charter" element={<AircraftCharter />} />
        <Route path="/dangerous-goods" element={<DangerousGoods />} />
        <Route path="/customs" element={<Customs />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/quote" element={<Quote />} />
        <Route path="/insights" element={<Insights />} />
        <Route path="/insights/:slug" element={<ArticleDetail />} />
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/cookie-policy" element={<CookiePolicy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
      {!isAdmin && <Footer />}
      {!isAdmin && <WhatsAppButton />}
      {!isAdmin && <CookieConsent />}
      <Toaster position="top-right" />
    </div>
  );
}

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <AppContent />
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
